<template>
  <div class="no-image">
    <a-spin class="spin-box" :spinning="loading">
      <div class="order" v-if="!loading && goodsInfo">
        <div class="pay-title">购课信息</div>
        <div class="goods">
          <div class="goods-show table-head">
            <div class="goods-name">课程</div>
            <!-- <div>价格</div> -->
            <div>环节</div>
            <div>有效期</div>
            <!-- <div>实付</div> -->
          </div>
          <div class="goods-show">
            <div class="goods-name">
              <i class="i-icon goods-cover" :style="{ backgroundImage: 'url(' + goodsInfo.cover + ')' }"></i>
              <div class="goods-info">
                <div>{{ goodsInfo.title }}</div>
                <!-- <div>{{ goodsInfo.unitCount }}个环节</div> -->
              </div>
            </div>
            <div>{{ goodsInfo.unitCount }}个环节</div>
            <!-- <div class="goods-price">￥{{ goodsInfo.price }}</div> -->
            <div class="goods-date">永久有效</div>
            <!-- <div class="goods-real-price">￥{{ goodsInfo.realPrice }}</div> -->
          </div>
        </div>
        <!-- 支付方式 -->
        <div class="pay-model">
          <!-- 优惠券 -->
          <!-- <div class="coupon">
            <p>优惠劵</p>
            <a-select class="coupon-select" size="large" ref="select" v-model:value="couponGuid" @change="handleChange" placeholder="选择优惠券" allowClear>
              <a-select-option :value="item.pk_couponGuid" v-for="item in couponList">{{ item.typeName }}</a-select-option>
            </a-select>
          </div>-->
          <div class="coupon">
            <p>激活码</p>
            <div class="coupon-input-box">
              <a-input-group compact class="coupon-group">
                <a-input class="coupon-input" v-model:value="activeCode" placeholder="请输入激活码" />
                <a-button class="coupon-button" type="primary" :loading="isVerifying" @click="getCoupon">验证</a-button>
              </a-input-group>
              <span class="coupon-notice">注意：请输入本课程对应的激活码</span>
            </div>
          </div>
          <!--  -->
          <div class="underline"></div>
          <!--  -->
          <div class="pay-count">
            <div class="count">
              <!-- <div class="all">
                <p>总价：</p>
                <span>￥{{ goodsInfo.price }}</span>
              </div>
              <div class="coupon" v-if="chooseCoupon">
                <p>优惠券</p>
                <span>- ￥{{ chooseCoupon.price }}</span>
              </div>-->
              <!-- <div class="underline"></div>
              <div class="amount">
                <p>需付金额：</p>
                <span :class="{ oldPrice: chooseCoupon }">￥{{ goodsInfo.price }}</span>
                <span v-if="chooseCoupon && goodsInfo.realPrice > -1">￥{{ goodsInfo.realPrice }}</span>
              </div>-->
              <a-button class="pay-btn" @click="newOrder" type="primary" :loading="isPaying">立即激活</a-button>
              <div class="vip-active" @click="routerVip">平台vip用户，请点击这里跳转激活</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 页脚 -->
      <foot v-if="!loading"></foot>
    </a-spin>
  </div>
</template>

<script>
import navroot from "@/component/public/nav/nav.vue";
import foot from "@/component/public/foot/foot.vue";
import VueQr from 'vue-qr/src/packages/vue-qr.vue';

import * as uuid from "uuid";

export default {
  name: 'payment',
  components: {
    navroot,
    VueQr, foot
  },
  data() {
    return {
      goodsGuid: '',
      couponGuid: null,
      activeCode: null,

      goodsInfo: null,
      user: null,
      chooseCoupon: null,
      intPay: null,

      select_style: {
        "background-color": "#d6defa4a",
      },

      couponList: [],
      allDigitalBook: [],

      loading: true,
      isPaying: false,
      isVerifying: false,
      actived: false,
    }
  },
  mounted() {
    this.goodsGuid = this.$route.params.id;

    const state = this.$store.state;
    this.user = state.userInfo;
    this.allDigitalBook = state.digitalBookList;
    this.getGoods();
  },
  methods: {
    //获取商品详情
    async getGoods() {
      let data = this.allDigitalBook.find(item => item.pk_digital_book_id == this.goodsGuid);
      data.realPrice = data.price;
      this.goodsInfo = data;

      this.findOrder();
    },
    //查找支付订单判断是否支付
    async findOrder() {
      let res = await this.$api.payorder.findPayOrder({ fk_goodsGuid: this.goodsGuid, fk_userGuid: this.user.PK_UserGuid });
      if (res.statusCode != 200) return this.$message.error(res.error);
      if (res.data?.isPaid) return this.payFinish();
      this.loading = false;
      this.getCouponList();
    },
    //获取优惠券
    async getCouponList() {
      let res = await this.$api.payorder.getCouponList({ fk_userGuid: this.user.PK_UserGuid, status: 1 });
      if (res.statusCode != 200) return;
      let data = res.data.filter(item => !item.deadline || (new Date(item.deadline) > new Date())) || [];
      data.forEach(item => {
        item.couponConfig = item.couponConfig ? JSON.parse(item.couponConfig) : '';
      })

      this.couponList = data.filter(item => item.couponType != "assign" || (item.couponConfig && item.couponConfig.fk_goodsGuid == this.goodsGuid))
    },
    //选择优惠券
    handleChange() {
      let chooseCoupon = this.couponList.find(item => item.pk_couponGuid == this.couponGuid);
      this.chooseCoupon = chooseCoupon ? chooseCoupon : null;
    },
    //计算优惠后价格
    calculatePrice() {
      let chooseCoupon = this.chooseCoupon;
      if (chooseCoupon.couponType == "assign") chooseCoupon.price = this.goodsInfo.price;
      let realPrice = this.goodsInfo.price - chooseCoupon.price;
      if (realPrice < 0) realPrice = 0;
      this.goodsInfo.realPrice = realPrice < 0;
    },
    //验证优惠券
    async getCoupon() {
      let activeCode = this.activeCode;
      if (!activeCode) return this.$message.warn("请先输入激活码");
      activeCode = activeCode.trim();

      if (this.isVerifying) return;
      this.isVerifying = true;

      let res = await this.$api.payorder.getCoupon(activeCode);
      this.isVerifying = false;

      if (res.statusCode != 200) return this.$message.error(res.message);

      if (!res.data) return this.$message.warn("验证失败，激活码不存在或已过期");
      let data = res.data;
      if (data.status == 2) return this.$message.warn("验证失败，激活码已被使用");
      if (data.deadline && new Date(data.deadline) < new Date()) return this.$message.warn("验证失败，激活码已过期");
      let couponConfig = data.couponConfig ? JSON.parse(data.couponConfig) : null;
      if (!couponConfig || couponConfig.fk_goodsGuid != this.goodsGuid) return this.$nzconfirm("验证失败，激活码与商品不匹配。（如果您拥有平台vip激活码，请点击右下角跳转激活）", () => { });

      this.$message.success("验证成功");
      this.chooseCoupon = data;
      this.calculatePrice();
      this.actived = true;
    },
    //下订单
    async newOrder() {
      if (this.isPaying) return;
      if (!this.actived) return this.$message.warn("请先验证激活码");

      this.isPaying = true;

      let goodsInfo = this.goodsInfo;
      let chooseCoupon = this.chooseCoupon;
      //下订单
      let newOrder = {
        pk_payorderGuid: uuid.v1(),
        fk_goodsGuid: this.goodsGuid,
        fk_userGuid: this.user.PK_UserGuid,
        payMoney: goodsInfo.realPrice,
        type: "digitalBook",
        isPaid: false,
        pk_couponGuid: chooseCoupon ? chooseCoupon.pk_couponGuid : ""
      }
      if (goodsInfo.realPrice == 0) {
        newOrder.isPaid = true;
        newOrder.payMoney = 0;
      }

      let res = await this.$api.payorder.newPayOrder(newOrder);
      if (res.statusCode != 200) return this.$message.error(res.message);

      this.payFinish();
      this.isPaying = false;
    },
    async payFinish() {
      //加入班级
      await this.$api.unifydata.joinClass({ userGuid: this.user.PK_UserGuid, code: this.goodsInfo.code , classType: 'textbook' });
      this.$router.push(`/payfinish/${this.goodsGuid}`);
    },
    //跳转vip
    routerVip() {
      this.$router.push(`/personal#vip`);
    }
  }
}


</script>

<style scoped lang="scss">
@import "./payment.scss";
</style>